import { useQuery } from "@tanstack/react-query";
import { siteApi } from "../api/site";

export const useThirdPartySites = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["third-party-sites"],
    queryFn: () => siteApi.getThirdPartySites(),
  });

  return {
    data: data?.data?.rows ?? [],
    isLoading,
    isError,
    error,
    refetch
  };
};